import type { ConnectorListParams } from '@/entities/connector/types';

/**
 * 커넥터 도메인의 React Query 캐시 키 팩토리
 *
 * 계층 구조:
 * - `all`        : ['connector']                              — 커넥터 관련 전체 캐시 무효화 시 사용
 * - `types`      : ['connector', 'types']                     — 커넥터 유형 목록 조회
 * - `typeSchema` : ['connector', 'typeSchema', {type}]        — 특정 커넥터 유형의 설정 스키마(필드 정의) 조회
 * - `list`       : ['connector', 'list']                      — 커넥터 목록 prefix (invalidation용)
 * - `lists`      : ['connector', 'list', {params}]            — 커넥터 인스턴스 목록 조회 (페이지네이션 파라미터 포함)
 * - `detail`     : ['connector', 'detail', {id}]              — 특정 커넥터 인스턴스 상세 조회
 *
 */
export const connectorKeys = {
  all: ['connector'] as const,
  types: () => [...connectorKeys.all, 'types'] as const,
  typeSchema: (type: string) => [...connectorKeys.all, 'typeSchema', type] as const,
  list: () => [...connectorKeys.all, 'list'] as const,
  lists: (params?: ConnectorListParams) => [...connectorKeys.all, 'list', params] as const,
  detail: (id: string) => [...connectorKeys.all, 'detail', id] as const,
} as const;
